import {
    apiRequest,
    lemburList
} from "../../../../../services/adapters/kepegawaian/monitoringlemburService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", lemburList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository